import { useEffect, useState } from 'react';
import { ConversationMessageDto } from '@endion/types';
import { DecodedApiError } from './parse-api-error.hook';

export const CLOSE_REASON_MESSAGES = {
  timeout: 'La conversación se cerró automáticamente por inactividad',
  maxMessages: 'La conversación se cerró automáticamente por exceder el límite de mensajes',
  rollback: 'Presiona el botón para intentar nuevamente.',
  maintenanceMode: 'Estamos realizando tareas de mantenimiento. Volveremos a estar operativos en breve.',
  unrecoverableError: 'Ocurrió un error inesperado',
} as const;

export function useCloseConversation({
  messages,
  decodedApiError,
}: {
  messages: ConversationMessageDto[];
  decodedApiError?: DecodedApiError | null;
}) {
  const [closeReasonMessage, setCloseReasonMessage] = useState<string | null>(null);

  useEffect(() => {
    // Steaming errors don't close the conversation
    if (!decodedApiError) return setCloseReasonMessage(null);

    if (decodedApiError.code === 'CONVERSATION_EXPIRED' || decodedApiError.code === 'NO_CONVERSATION_FOUND') {
      return setCloseReasonMessage(CLOSE_REASON_MESSAGES.timeout);
    }

    if (decodedApiError.code === 'STREAMING_ERROR' || decodedApiError.code === 'LLM_ERROR') {
      return setCloseReasonMessage(CLOSE_REASON_MESSAGES.rollback);
    }

    if (decodedApiError.code === 'APP_MAINTENANCE_MODE') {
      return setCloseReasonMessage(CLOSE_REASON_MESSAGES.maintenanceMode);
    }

    return setCloseReasonMessage(CLOSE_REASON_MESSAGES.unrecoverableError);
  }, [decodedApiError?.code]);

  // close the conversation if has 50 or more messages
  useEffect(() => {
    if (messages.length >= 50) {
      setCloseReasonMessage(CLOSE_REASON_MESSAGES.maxMessages);
    }
  }, [messages]);

  return { closeReasonMessage, setCloseReasonMessage };
}
